import React from "react";
import TouchWithUs from "../../components/UserSideComponents/Home/TouchWithUs";
import Banner from "../../components/UserSideComponents/abouts/Banner";
import { Form } from "../../components/UserSideComponents/contact/Form";
// import Banner from "../../components/UserSideComponents/contact/Banner";

const ContactUs = () => {
  return (
    <div className="my-8">
      <Banner title="Contact Us" />
      <Form />
      <TouchWithUs />
    </div>
  );
};

export default ContactUs;
